import { Link } from '@tanstack/react-router'
import { AppShellBarLink, AppShellBottomBar, AppShellNavLink } from '@volee/ui'

import { messages } from '../messages/index.ts'
import type { BarNavigation } from './bar.ts'
import type { NavigationEntry } from './entries.ts'

// The rows of the menu, one flat list with no headings, for the column from `lg`. Below it the
// same entries are the bottom bar's (`BarSections`), and no drawer is drawn.

export function NavSections({ entries }: { entries: readonly NavigationEntry[] }) {
  return entries.map((entry) => (
    // `asChild` on the nav link, not on the Link: TanStack's Link does not accept it. And
    // `exact`, or the router marks every prefix of the path current — two current rows.
    <AppShellNavLink
      key={entry.path}
      asChild
      active={entry.active}
      icon={entry.icon}
      label={entry.label}
    >
      <Link to={entry.path} activeOptions={{ exact: true }} />
    </AppShellNavLink>
  ))
}

function BarEntry({ entry }: { entry: NavigationEntry }) {
  return (
    <AppShellBarLink asChild active={entry.active} icon={entry.icon} label={entry.label}>
      <Link to={entry.path} activeOptions={{ exact: true }} />
    </AppShellBarLink>
  )
}

/** The same destinations below `lg`, in the bar: home in the middle, the rest by priority. */
export function BarSections({ bar }: { bar: BarNavigation }) {
  return (
    <AppShellBottomBar
      home={<BarEntry entry={bar.home} />}
      label={messages.app.navigationLabel}
      moreLabel={messages.navigation.more}
      closeLabel={messages.navigation.closeMore}
    >
      {bar.others.map((entry) => (
        <BarEntry key={entry.path} entry={entry} />
      ))}
    </AppShellBottomBar>
  )
}
